import React, { useState } from "react";
import axios from "axios";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Container,
  FormGroup,
  FormText,
  Form,
  Input,
  Label,
  Row,
  Col
} from "reactstrap";
import { useNavigate } from "react-router-dom";

const AddContactUs = () => {
  const [formData, setFormData] = useState({
    name: "",
    profileImage: null,
    phoneNumber: "",
    whatsappNo: "",
    email: "",
    designation: "",
    role: "",
    priority: "",
    type: ""
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setFormData({
      ...formData,
      profileImage: file
    });
  };

  const navigate = useNavigate()
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const formDataToSend = new FormData();
      for (const key in formData) {
        formDataToSend.append(key, formData[key]);
      }
      const response = await axios.post(`${process.env.REACT_APP_EXPRESS_API}createContactUs`, formDataToSend, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      });
      console.log("Response:", response.data);


      // Clear form after successful submission
      setFormData({
        name: "",
        profileImage: null,
        phoneNumber: "",
        whatsappNo: "",
        email: "",
        designation: "",
        role: "",
        priority: "",
        type: ""
      });
      navigate('/admin/contactUs')
    } catch (error) {
      console.error("Error:", error);
      alert("Failed to add contact. Please try again.");
    }
  };

  return (
    <>
      <Container className="pt-7">
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0 d-flex justify-content-between ">
                <h3 className="mb-0">Add Contact</h3>
              </CardHeader>
              <CardBody>
                <div>
                  <Form onSubmit={handleSubmit}>
                  <Row>
                      <Col md={6}>
                        <FormGroup>
                          <Label for="name">Name</Label>
                          <Input
                            type="text"
                            id="name"
                            name="name"
                            placeholder="Enter Name"
                            value={formData.name}
                            onChange={handleChange}
                          />
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup>
                          <Label for="profileImage">Profile Image</Label>
                          <Input
                            type="file"
                            id="profileImage"
                            name="profileImage"
                            onChange={handleImageChange}
                          />
                          <FormText color="muted">
                            Choose a profile image
                          </FormText>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <Label for="phoneNumber">Phone No.</Label>
                          <Input
                            type="text"
                            id="phoneNumber"
                            name="phoneNumber"
                            placeholder="Enter Phone No."
                            value={formData.phoneNumber}
                            onChange={handleChange}
                          />
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup>
                          <Label for="whatsappNo">Whatsapp No.</Label>
                          <Input
                            type="text"
                            id="whatsappNo"
                            name="whatsappNo"
                            placeholder="Enter Whatsapp No."
                            value={formData.whatsappNo}
                            onChange={handleChange}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <Label for="email">Email</Label>
                          <Input
                            type="email"
                            id="email"
                            name="email"
                            placeholder="Enter Email"
                            value={formData.email}
                            onChange={handleChange}
                          />
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup>
                          <Label for="designation">Designation</Label>
                          <Input
                            type="text"
                            id="designation"
                            name="designation"
                            placeholder="Enter Designation"
                            value={formData.designation}
                            onChange={handleChange}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <Label for="role">Role</Label>
                          <Input
                            type="select"
                            id="role"
                            name="role"
                            value={formData.role}
                            onChange={handleChange}
                          >
                            <option value="">Select Role</option>
                            <option value="Admin">Admin</option>
                            <option value="Manager">Manager</option>
                            <option value="Employee">Employee</option>
                          </Input>
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup>
                          <Label for="priority">Priority</Label>
                          <Input
                            type="number"
                            id="priority"
                            name="priority"
                            placeholder="Enter Priority"
                            value={formData.priority}
                            onChange={handleChange}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                <Col md={12}>
                        <FormGroup>
                          <Label for="exampleEmail">Type</Label>
                          <Input id="typw" name="type" type="select"  value={formData.type}
                            onChange={handleChange}>
                            <option value="driver">select option</option>
                            <option value="user">Tutor</option>
                            <option value="both">Student</option>
                          </Input>
                        </FormGroup>
                      </Col>
                      </Row>
                    {/* Add rest of the form fields here */}
                    <Button color="secondary">Cancel</Button>
                    <Button
                      color="primary"
                      type="submit"
                      style={{
                        float: "right",
                        marginLeft: "5%",
                        backgroundColor: "#080278",
                        color: "white",
                        border: "none"
                      }}
                    >
                      Save
                    </Button>
                  </Form>
                </div>
              </CardBody>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default AddContactUs;
